<template>
  <div class="tabla-productos">
    <!-- Encabezado de columnas (solo desktop) -->
    <div class="tabla-productos__header">
      <span class="tabla-productos__header-col tabla-productos__header-col--producto">
        Producto
      </span>
      <span class="tabla-productos__header-col tabla-productos__header-col--categoria">
        Categoría
      </span>
      <span class="tabla-productos__header-col tabla-productos__header-col--right">
        Tipo / Acciones
      </span>
    </div>

    <!-- Lista -->
    <div v-if="productos && productos.length" class="tabla-productos__list">
      <div
        v-for="producto in productos"
        :key="producto.id_producto"
        class="tabla-productos__row"
      >
        <!-- Columna: Producto (60%) -->
        <div class="tabla-productos__col tabla-productos__col--producto">
          <div class="tabla-productos__avatar">
            <img
              v-if="producto.imagen_principal_url || producto.imagen_principal"
              :src="producto.imagen_principal_url || producto.imagen_principal"
              :alt="producto.nombre || 'Producto'"
              class="tabla-productos__avatar-img"
            />
            <span v-else>{{ initials(producto.nombre) }}</span>
          </div>
          <div class="tabla-productos__info">
            <p class="tabla-productos__nombre">
              {{ producto.nombre || 'Sin nombre' }}
            </p>
            <p class="tabla-productos__id">
              ID #{{ producto.id_producto }}
            </p>
          </div>
        </div>

        <!-- Columna: Categoría (espacio entre producto y derecha) -->
        <div class="tabla-productos__col tabla-productos__col--categoria">
          <span class="tabla-productos__categoria">
            {{ producto.categoria || '—' }}
          </span>
        </div>

        <!-- Columna: Tipo + Acciones (alineado a la derecha) -->
        <div class="tabla-productos__col tabla-productos__col--right">
          <span
            class="tabla-productos__tipo-chip"
            :class="{
              'is-principal': producto.tipo_producto === 'principal',
              'is-complemento': producto.tipo_producto !== 'principal',
            }"
          >
            {{ tipoLabel(producto.tipo_producto) }}
          </span>

          <!-- Botón editar -->
          <button
            v-if="$canView && $canView('superadministrador', 'administrador')"
            type="button"
            class="tabla-productos__action tabla-productos__action--edit"
            @click="$emit('editar', producto)"
          >
            ✏️
          </button>

          <!-- Botón + (solo principal) o placeholder invisible -->
          <button
            v-if="
              $canView &&
              $canView('superadministrador', 'administrador') &&
              producto.tipo_producto === 'principal'
            "
            type="button"
            class="tabla-productos__action tabla-productos__action--comp"
            @click="$emit('asignar', producto.id_producto)"
          >
            ➕
          </button>
          <span
            v-else
            class="tabla-productos__action tabla-productos__action--placeholder"
          ></span>
        </div>
      </div>
    </div>

    <!-- Vacío -->
    <div v-else class="tabla-productos__empty">
      No hay productos registrados.
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablaProductos',
  props: {
    productos: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    initials(nombre) {
      if (!nombre) return 'P';
      const parts = String(nombre).split(' ').filter(Boolean);
      const first = parts[0]?.[0] || '';
      const second = parts[1]?.[0] || '';
      const i = (first + second).toUpperCase();
      return i || 'P';
    },
    tipoLabel(tipo) {
      const t = String(tipo || '').toLowerCase();
      if (t === 'principal') return 'Principal';
      if (t === 'complemento') return 'Complemento';
      return t.charAt(0).toUpperCase() + t.slice(1);
    },
  },
};
</script>

<style scoped lang="scss">
.tabla-productos {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

/* Encabezado (desktop) */
.tabla-productos__header {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.35rem 0.35rem;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #9ca3af;
}

.tabla-productos__header-col {
  white-space: nowrap;
}

.tabla-productos__header-col--producto {
  flex: 0 0 60%;
  max-width: 60%;
  padding-left: 0.2rem;
}

.tabla-productos__header-col--categoria {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}

.tabla-productos__header-col--right {
  flex: 0 0 auto;
  text-align: right;
}

/* Lista / filas */
.tabla-productos__list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tabla-productos__row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 0.6rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.4);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.7);
}

/* Columnas */
.tabla-productos__col {
  display: flex;
  align-items: center;
  min-width: 0;
}

/* Producto = 60% */
.tabla-productos__col--producto {
  flex: 0 0 60%;
  max-width: 60%;
  min-width: 0;
  gap: 0.55rem;
}

/* Categoría = espacio restante entre producto y derecha */
.tabla-productos__col--categoria {
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-start;
}

/* Derecha = chip + botones pegados al borde derecho */
.tabla-productos__col--right {
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: 0.25rem;
}

/* Avatar / info producto */
.tabla-productos__avatar {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.28),
    rgba(15, 23, 42, 1)
  );
  border: 1px solid rgba(148, 163, 184, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #e5e7eb;
  flex-shrink: 0;
  overflow: hidden;
}

.tabla-productos__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tabla-productos__info {
  min-width: 0;
}

.tabla-productos__nombre {
  font-size: 0.85rem;
  color: #e5e7eb;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tabla-productos__id {
  font-size: 0.7rem;
  color: #9ca3af;
}

/* Categoría */
.tabla-productos__categoria {
  font-size: 0.78rem;
  color: #cbd5f5;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Tipo chip */
.tabla-productos__tipo-chip {
  font-size: 0.7rem;
  padding: 0.12rem 0.6rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.95);
  color: #e5e7eb;
  white-space: nowrap;
}

.tabla-productos__tipo-chip.is-principal {
  border-color: rgba(34, 197, 94, 0.9);
  color: #bbf7d0;
}

.tabla-productos__tipo-chip.is-complemento {
  border-color: rgba(129, 140, 248, 0.9);
  color: #e0e7ff;
}

/* Acciones */
.tabla-productos__action {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  background: rgba(15, 23, 42, 0.96);
  color: #e5e7eb;
  width: 28px;
  height: 28px;
  font-size: 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition:
    background 0.16s ease,
    transform 0.1s ease,
    box-shadow 0.16s ease;
  flex-shrink: 0;
}

.tabla-productos__action--comp {
  border-color: rgba(129, 140, 248, 0.9);
}

/* Placeholder para mantener alineación del lápiz */
.tabla-productos__action--placeholder {
  visibility: hidden;
}

.tabla-productos__action:hover:not(.tabla-productos__action--placeholder) {
  background: rgba(15, 23, 42, 1);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.9);
}

.tabla-productos__action:active:not(.tabla-productos__action--placeholder) {
  transform: translateY(0);
  box-shadow: 0 5px 16px rgba(15, 23, 42, 1);
}

/* Estado vacío */
.tabla-productos__empty {
  font-size: 0.8rem;
  color: #e5e7eb;
  padding: 0.4rem 0.3rem;
  text-align: left;
}

/* Responsive */
@media (max-width: 768px) {
  .tabla-productos__header {
    display: none;
  }

  .tabla-productos__row {
    flex-direction: column;
    align-items: stretch;
  }

  .tabla-productos__col--producto {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .tabla-productos__col--categoria {
    margin-top: 0.15rem;
  }

  .tabla-productos__col--right {
    margin-top: 0.25rem;
    justify-content: flex-start;
  }
}
</style>
